import { render, staticRenderFns } from "./CustomerProperties.vue?vue&type=template&id=f72233cc&scoped=true&"
import script from "./CustomerProperties.vue?vue&type=script&lang=js&"
export * from "./CustomerProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72233cc",
  null
  
)

export default component.exports